export default __webpack_public_path__ + "d3c8798ff46a3342fc0f56a36113d20a.svg";